import Icon from "components/Icon/Icon";
import LinkButton from "components/LinkButton";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  gap: 15px;
`;

export const Wrapper = styled.div`
  && {
    font-size: 12px;
    flex: 0 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${(props) => props.theme.black50};
    flex-grow: 1;
    row-gap: 4px;
    column-gap: 10px;
    min-height: 43px;
    align-items: flex-start;

    ${(props) => props.theme.xs`
      flex-direction: row;
      align-items: center;
    `}
  }
`;

export const OpenNotFinishedButton = styled(LinkButton).attrs({
  tone: "muted",
})`
  display: flex;
  align-items: center;
  padding: 10px 0;
  margin-right: 20px;
  font-size: inherit;

  span {
    font-weight: 700;
    margin-left: 4px;
  }

  ${(props) => props.theme.md`
    margin-left: auto;
  `}

  ${(props) => props.theme.xs`
    padding: 0;

    span {
      margin-left: 0;
    }
  `}
`;

export const RightArrowIcon = styled(Icon)`
  width: 8px;
  height: 14px;
  margin-left: 6px;
  transition: opacity 0.2s;
`;
